import { render, staticRenderFns } from "./ChatCloseSettingsButton.vue?vue&type=template&id=6068cf74&scoped=true"
import script from "./ChatCloseSettingsButton.vue?vue&type=script&lang=js"
export * from "./ChatCloseSettingsButton.vue?vue&type=script&lang=js"
import style0 from "./ChatCloseSettingsButton.vue?vue&type=style&index=0&id=6068cf74&prod&lang=scss"
import style1 from "./ChatCloseSettingsButton.vue?vue&type=style&index=1&id=6068cf74&prod&lang=scss&scoped=true"
import style2 from "./ChatCloseSettingsButton.vue?vue&type=style&index=2&id=6068cf74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6068cf74",
  null
  
)

export default component.exports